import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";
import { FormSection } from "./fields/FormSection";

export const RentersWarehouseCredentialForm = ({
  register
}: CredentialFormProps) => (
  <>
    <BaseInput
      id="renters_warehouse_api_key"
      label="API Key"
      {...register("renters_warehouse_api_key")}
      required
    />
    <BaseInput
      id="renters_warehouse_url"
      label="URL"
      {...register("renters_warehouse_url")}
      required
    />
    <FormSection title="Salesforce" gap="sm">
      <BaseInput
        id="renters_warehouse_salesforce_domain"
        label="Salesforce Domain"
        {...register("renters_warehouse_salesforce_domain")}
        required
      />
      <BaseInput
        id="renters_warehouse_salesforce_client_id"
        label="Salesforce Client ID"
        {...register("renters_warehouse_salesforce_client_id")}
        required
      />
      <BaseInput
        id="renters_warehouse_salesforce_client_secret"
        label="Salesforce Client Secret"
        {...register("renters_warehouse_salesforce_client_secret")}
        required
      />
      <BaseInput
        id="renters_warehouse_salesforce_username"
        label="Salesforce Username"
        {...register("renters_warehouse_salesforce_username")}
        required
      />
      <BaseInput
        id="renters_warehouse_salesforce_password"
        label="Salesforce Password"
        {...register("renters_warehouse_salesforce_password")}
        required
      />
    </FormSection>
  </>
);
